/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // ============================================================================
  // Move Rewards & Chat buttons above cookie consent banner
  // ============================================================================

  function initFloatingButtonPositions() {
    const BANNER_HEIGHT = 150; // pixels to move buttons up when banner visible (desktop)
    const MOBILE_BREAKPOINT = 768; // pixels

    // Check if we're on mobile
    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    // Create a style element for Smile.io positioning
    // Based on research: Smile.io uses iframes, must target container with CSS !important
    // Reference: https://stackoverflow.com/questions/71534772/how-to-style-shopify-2-0-inbox-chat-icon-inside-an-iframe
    let smileStyleEl = null;
    function getSmileStyle() {
      if (!smileStyleEl) {
        smileStyleEl = document.createElement('style');
        smileStyleEl.id = 'smile-position-override';
        document.head.appendChild(smileStyleEl);
      }
      return smileStyleEl;
    }

    // Function to find and move/hide the Smile.io Rewards button
    function moveRewardsButton(bannerVisible) {
      const styleEl = getSmileStyle();
      const mobile = isMobile();

      if (mobile && bannerVisible) {
        // On mobile: hide when banner is visible
        styleEl.textContent = `
          .smile-launcher-frame-container,
          .smile-ui-lite-container,
          #smile-ui-container,
          [class*="smile-launcher"],
          [id*="smile-ui"],
          div[class*="smile"][style*="fixed"],
          .sweettooth-launcher {
            opacity: 0 !important;
            pointer-events: none !important;
            transition: opacity 0.3s ease !important;
          }
        `;
      } else if (mobile) {
        // On mobile: show on LEFT side, positioned at bottom to match Chat button
        styleEl.textContent = `
          .smile-launcher-frame-container,
          .smile-ui-lite-container,
          #smile-ui-container,
          [class*="smile-launcher"],
          [id*="smile-ui"],
          div[class*="smile"][style*="fixed"],
          .sweettooth-launcher {
            opacity: 1 !important;
            pointer-events: auto !important;
            transition: opacity 0.3s ease !important;
            left: 10px !important;
            right: auto !important;
            bottom: 5px !important;
          }
        `;
      } else {
        // On desktop: move up/down based on banner visibility, keep on LEFT side
        // Match Chat button position (5px from bottom)
        const bottomValue = bannerVisible ? BANNER_HEIGHT : 5;
        styleEl.textContent = `
          .smile-launcher-frame-container,
          .smile-ui-lite-container,
          #smile-ui-container,
          [class*="smile-launcher"],
          [id*="smile-ui"],
          div[class*="smile"][style*="fixed"],
          .sweettooth-launcher {
            bottom: ${bottomValue}px !important;
            transition: bottom 0.3s ease !important;
            left: 20px !important;
            right: auto !important;
          }
        `;
      }

    }

    // Function to find and move/hide the Shopify Inbox Chat button
    function moveChatButton(bannerVisible) {
      const chatContainer = document.querySelector('inbox-online-store-chat') ||
                            document.querySelector('.chat-app');
      if (chatContainer) {
        const mobile = isMobile();

        if (mobile && bannerVisible) {
          // On mobile: hide when banner is visible
          chatContainer.style.setProperty('opacity', '0', 'important');
          chatContainer.style.setProperty('pointer-events', 'none', 'important');
          chatContainer.style.setProperty('transition', 'opacity 0.3s ease', 'important');
        } else if (mobile) {
          // On mobile: show at normal position
          chatContainer.style.setProperty('opacity', '1', 'important');
          chatContainer.style.setProperty('pointer-events', 'auto', 'important');
          chatContainer.style.setProperty('bottom', '0px', 'important');
          chatContainer.style.setProperty('transition', 'opacity 0.3s ease', 'important');
        } else {
          // On desktop: move up/down
          chatContainer.style.setProperty('opacity', '1', 'important');
          chatContainer.style.setProperty('pointer-events', 'auto', 'important');
          chatContainer.style.setProperty('bottom', bannerVisible ? BANNER_HEIGHT + 'px' : '0px', 'important');
          chatContainer.style.setProperty('transition', 'bottom 0.3s ease', 'important');
        }
      }
    }

    // Check if cookie consent banner is visible
    function isBannerVisible() {
      // Check for Shopify's native privacy/consent banner (multiple possible selectors)
      const shopifyBannerSelectors = [
        '#shopify-pc__banner',
        '.shopify-pc__banner',
        '.shopify-pc-banner',
        '[id*="shopify-pc"]',
        '[class*="shopify-pc"]',
        'shopify-privacy-consent',
        '#PolicyNotice',
        '.cc-banner',
        '[data-consent-banner]'
      ];

      for (const selector of shopifyBannerSelectors) {
        const banner = document.querySelector(selector);
        if (banner && banner.offsetHeight > 0 && banner.offsetWidth > 0) {
          const rect = banner.getBoundingClientRect();
          // Check if it's actually visible on screen (not hidden above/below viewport)
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            return true;
          }
        }
      }

      // Check theme's cookie popup
      const themePopup = document.querySelector('[data-tracking-consent] [data-popup-inner]');
      if (themePopup) {
        const computedStyle = window.getComputedStyle(themePopup);
        if (computedStyle.display !== 'none' && parseFloat(computedStyle.opacity) > 0) {
          return true;
        }
      }

      // Last resort: look for any fixed/sticky element at bottom with consent-related text
      const allFixedElements = document.querySelectorAll('*');
      for (const el of allFixedElements) {
        const style = window.getComputedStyle(el);
        if ((style.position === 'fixed' || style.position === 'sticky') &&
            el.offsetHeight > 40 && el.offsetHeight < 200 &&
            el.textContent && el.textContent.toLowerCase().includes('cookie')) {
          const rect = el.getBoundingClientRect();
          if (rect.bottom >= window.innerHeight - 10) {
            return true;
          }
        }
      }

      return false;
    }

    // Update button positions based on banner visibility
    function updateButtonPositions() {
      const visible = isBannerVisible();
      moveRewardsButton(visible);
      moveChatButton(visible);
    }

    // Watch for style changes on popup elements
    let popupObserver = null;
    let shopifyBannerObserver = null;

    function startObserving() {
      // Observe theme popup for style changes (display/opacity)
      const themePopup = document.querySelector('[data-tracking-consent] [data-popup-inner]');
      if (themePopup && !popupObserver) {
        popupObserver = new MutationObserver(() => {
          updateButtonPositions();
        });
        popupObserver.observe(themePopup, { attributes: true, attributeFilter: ['style', 'class'] });
      }

      // Observe Shopify's native consent banner for style/attribute changes
      const shopifyBanner = document.querySelector('#shopify-pc__banner');
      if (shopifyBanner && !shopifyBannerObserver) {
        shopifyBannerObserver = new MutationObserver(() => {
          updateButtonPositions();
        });
        shopifyBannerObserver.observe(shopifyBanner, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
        });
        // Also observe parent for removal
        if (shopifyBanner.parentElement) {
          shopifyBannerObserver.observe(shopifyBanner.parentElement, { childList: true });
        }
      }
    }

    // Watch for DOM changes (elements added/removed)
    const bodyObserver = new MutationObserver((mutations) => {
      let shouldUpdate = false;

      for (const mutation of mutations) {
        // Check for added nodes (widgets loading)
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.matches && (
                node.matches('.smile-launcher-frame-container, inbox-online-store-chat, [data-tracking-consent], #shopify-pc__banner') ||
                node.querySelector && node.querySelector('.smile-launcher-frame-container, inbox-online-store-chat, [data-tracking-consent], #shopify-pc__banner')
            )) {
              startObserving();
              shouldUpdate = true;
            }
          }
        }

        // Check for removed nodes (banner dismissed)
        for (const node of mutation.removedNodes) {
          if (node.nodeType === 1) {
            if (node.id === 'shopify-pc__banner' ||
                (node.matches && node.matches('[id*="shopify-pc"], [class*="shopify-pc"]'))) {
              shouldUpdate = true;
            }
          }
        }
      }

      if (shouldUpdate) {
        updateButtonPositions();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    // Initialize
    startObserving();
    updateButtonPositions();

    // Keep checking as widgets load asynchronously (Smile.io can be slow)
    [500, 1000, 2000, 3000, 5000, 8000].forEach(delay => {
      setTimeout(() => {
        startObserving();
        updateButtonPositions();
      }, delay);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingButtonPositions);
  } else {
    initFloatingButtonPositions();
  }

  // ============================================================================
  // Hide Rewards & Chat widgets when cart drawer is open on mobile
  // Uses same dynamic style injection pattern as cookie banner hiding
  // ============================================================================

  function initCartDrawerWidgetHiding() {
    const MOBILE_BREAKPOINT = 768;

    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    // Create a dedicated style element for drawer-based hiding
    let drawerStyleEl = null;
    function getDrawerStyle() {
      if (!drawerStyleEl) {
        drawerStyleEl = document.createElement('style');
        drawerStyleEl.id = 'drawer-widget-hide';
        document.head.appendChild(drawerStyleEl);
      }
      return drawerStyleEl;
    }

    // Hide/show widgets using injected CSS (same pattern as cookie banner code)
    function setWidgetsHidden(hide) {
      const styleEl = getDrawerStyle();

      if (hide && isMobile()) {
        // Hide both Smile.io and Chat widgets
        styleEl.textContent = `
          .smile-launcher-frame-container,
          .smile-ui-lite-container,
          #smile-ui-container,
          [class*="smile-launcher"],
          [id*="smile-ui"],
          div[class*="smile"][style*="fixed"],
          .sweettooth-launcher,
          button.smile-improved-mobile-launcher,
          inbox-online-store-chat,
          .chat-app {
            opacity: 0 !important;
            pointer-events: none !important;
            visibility: hidden !important;
            transition: opacity 0.2s ease !important;
          }
        `;
      } else {
        // Clear the hiding styles
        styleEl.textContent = '';
      }
    }

    // Check drawer state based on class
    function isDrawerOpen() {
      const drawer = document.querySelector('.drawer.drawer--visible, .drawer.is-open');
      return !!drawer;
    }

    function checkAndUpdate() {
      setWidgetsHidden(isDrawerOpen());
    }

    // Observe drawer for class changes
    function observeDrawers() {
      const drawers = document.querySelectorAll('.drawer');
      drawers.forEach(drawer => {
        if (drawer.dataset.drawerWidgetObserver) return;
        drawer.dataset.drawerWidgetObserver = 'true';

        const observer = new MutationObserver(() => {
          checkAndUpdate();
        });
        observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      });
    }

    // Watch for drawers being added to DOM
    const bodyObserver = new MutationObserver(() => {
      observeDrawers();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    // Initialize
    observeDrawers();
    checkAndUpdate();

    // Re-check on window resize
    window.addEventListener('resize', checkAndUpdate);
  }

  // Initialize cart drawer widget hiding
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerWidgetHiding);
  } else {
    initCartDrawerWidgetHiding();
  }

  // ============================================================================
  // Sync product grid sizes with swatch selection
  // When a color swatch is clicked, show the sizes for that color variant
  // Works with both sibling swatches and variant swatches
  // ============================================================================

  function initSwatchSizesSync() {
    // Listen for clicks on any swatch link (siblings or variant swatches)
    document.addEventListener('click', function(e) {
      // Handle sibling swatch links
      let swatchLink = e.target.closest('a[data-sibling-swatch-link]');

      // Also handle variant swatch links (radio-swatch)
      if (!swatchLink) {
        swatchLink = e.target.closest('a[data-grid-item-variant]');
      }

      if (!swatchLink) return;

      const variantId = swatchLink.getAttribute('data-grid-item-variant');
      if (!variantId) return;

      // Find the parent product-grid-item container
      const gridItem = swatchLink.closest('product-grid-item');
      if (!gridItem) return;

      // Find all sizes wrappers in this grid item and show/hide based on variant
      const sizesWrappers = gridItem.querySelectorAll('[data-sizes-for-variant]');
      if (sizesWrappers.length === 0) return;

      sizesWrappers.forEach(function(wrapper) {
        const wrapperVariantId = wrapper.getAttribute('data-sizes-for-variant');
        if (wrapperVariantId === variantId) {
          wrapper.removeAttribute('hidden');
        } else {
          wrapper.setAttribute('hidden', '');
        }
      });
    });
  }

  // Initialize swatch sizes sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchSizesSync);
  } else {
    initSwatchSizesSync();
  }

  // ============================================================================
  // Product Grid Sizes - AJAX Add to Cart
  // Handles the size buttons on product cards to add to cart via AJAX
  // and show the cart popdown modal instead of redirecting
  // ============================================================================

  function initSizeButtonAddToCart() {
    const LOADING_CLASS = 'loading';
    const SUCCESS_CLASS = 'has-success';
    const SUCCESS_DURATION = 2000;

    // Handle form submission
    document.addEventListener('submit', function(e) {
      const form = e.target.closest('form[data-size-add-form]');
      if (!form) return;

      e.preventDefault();

      const button = form.querySelector('button[data-add-to-cart]');
      if (!button || button.disabled) return;

      // Set loading state
      button.classList.add(LOADING_CLASS);
      button.disabled = true;

      // Get form data
      const formData = new FormData(form);
      const formPayload = new URLSearchParams(formData).toString();

      // Add to cart via AJAX
      fetch(window.theme.routes.cart + '/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formPayload
      })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(data) {
            throw data;
          });
        }
        return response.json();
      })
      .then(function(variant) {
        // Success - show checkmark
        button.classList.remove(LOADING_CLASS);
        button.classList.add(SUCCESS_CLASS);

        // Update cart count in header
        fetch(window.theme.routes.cart + '.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart: cart },
              bubbles: true
            }));
          });

        // Open the cart popdown modal
        document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
          detail: { variant: variant },
          bubbles: true
        }));

        // Reset button state after delay
        setTimeout(function() {
          button.classList.remove(SUCCESS_CLASS);
          button.disabled = false;
        }, SUCCESS_DURATION);
      })
      .catch(function(error) {
        // Error - reset button
        button.classList.remove(LOADING_CLASS);
        button.disabled = false;

        // Show error if available
        const errorMsg = error.description || error.message || 'Could not add to cart';

        // Find error display element
        const errorBoundary = form.closest('[data-error-boundary]');
        const errorDisplay = errorBoundary ? errorBoundary.querySelector('[data-error-display]') : null;

        if (errorDisplay) {
          errorDisplay.innerHTML = '<div class="errors">' + errorMsg + '</div>';
          errorDisplay.style.display = 'block';
          setTimeout(function() {
            errorDisplay.style.display = '';
            errorDisplay.innerHTML = '';
          }, 5000);
        }
      });
    });
  }

  // Initialize size button add to cart
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeButtonAddToCart);
  } else {
    initSizeButtonAddToCart();
  }

  // ============================================================================
  // Swatch Luminance Detection
  // Adds swatch--light or swatch--dark class to swatches based on color luminance
  // Used to show appropriate selection indicator (white ring on dark, black on light)
  // ============================================================================

  function initSwatchLuminance() {
    // Calculate relative luminance of a color (0 = black, 1 = white)
    // Using WCAG formula: https://www.w3.org/TR/WCAG20/#relativeluminancedef
    function getLuminance(r, g, b) {
      const [rs, gs, bs] = [r, g, b].map(function(c) {
        c = c / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * rs + 0.7152 * gs + 0.0722 * bs;
    }

    // Parse a CSS color string and return RGB values
    function parseColor(colorStr) {
      if (!colorStr) return null;

      // Handle hex colors
      if (colorStr.startsWith('#')) {
        let hex = colorStr.slice(1);
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        if (hex.length === 6) {
          return {
            r: parseInt(hex.slice(0, 2), 16),
            g: parseInt(hex.slice(2, 4), 16),
            b: parseInt(hex.slice(4, 6), 16)
          };
        }
      }

      // Handle rgb/rgba colors
      const rgbMatch = colorStr.match(/rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
      if (rgbMatch) {
        return {
          r: parseInt(rgbMatch[1], 10),
          g: parseInt(rgbMatch[2], 10),
          b: parseInt(rgbMatch[3], 10)
        };
      }

      return null;
    }

    // Process a single swatch element
    function processSwatch(swatch) {
      // Skip if already processed
      if (swatch.dataset.luminanceProcessed) return;
      swatch.dataset.luminanceProcessed = 'true';

      // Get the swatch color from inline style or computed style
      const style = swatch.getAttribute('style') || '';
      const swatchMatch = style.match(/--swatch:\s*([^;]+)/i);

      let colorStr = null;
      if (swatchMatch) {
        colorStr = swatchMatch[1].trim();
      } else {
        // Try computed style
        const computed = window.getComputedStyle(swatch);
        colorStr = computed.getPropertyValue('--swatch').trim();
      }

      if (!colorStr) return;

      const rgb = parseColor(colorStr);
      if (!rgb) return;

      const luminance = getLuminance(rgb.r, rgb.g, rgb.b);

      // Add class based on luminance (threshold 0.5 is a good middle ground)
      // Lower luminance = darker color = needs white indicator
      if (luminance < 0.4) {
        swatch.classList.add('swatch--dark');
        swatch.classList.remove('swatch--light');
      } else {
        swatch.classList.add('swatch--light');
        swatch.classList.remove('swatch--dark');
      }
    }

    // Process all swatches on the page
    function processAllSwatches() {
      const swatches = document.querySelectorAll('.swatch__button label[data-swatch], .swatch__button label[style*="--swatch"]');
      swatches.forEach(processSwatch);
    }

    // Initial processing
    processAllSwatches();

    // Watch for dynamically added swatches (quick view, etc.)
    const observer = new MutationObserver(function(mutations) {
      let shouldProcess = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.matches && (node.matches('.swatch__button') || node.querySelector && node.querySelector('.swatch__button'))) {
                shouldProcess = true;
              }
            }
          });
        }
      });
      if (shouldProcess) {
        // Small delay to ensure styles are applied
        setTimeout(processAllSwatches, 50);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initialize swatch luminance detection
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchLuminance);
  } else {
    initSwatchLuminance();
  }

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
